import React, { Component } from 'react';

import classNames from 'classnames';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import { Menu } from '@uncinc/react-drupal-core';
import { Container, NavigationScroll, Button } from '@uncinc/uncinc-react-kitchen-sink';

import { Hamburger, Logo } from '../../../components';
import { showNavMenu, hideNavMenu } from '../../../actions/UI';
import { TRANSPARENT_NAV_CONTENT_TYPE } from '../../../config/constants';
import NavigationSecondaryMenu from '../../Menus/NavigationSecondaryMenu';
import GenericNavigationMainMenu from '../../Menus/GenericNavigationMainMenu';
import GenericNavigationMainMobile from '../../Menus/GenericNavigationMainMenuMobile';

import './style.scss';

class MaatjesHeader extends Component {
  constructor(props) {
    super(props);
    this.state = {
      menuIsOpen: false,
      menuItemsToggled: [],
    };
  }

  onHamburgerClick = () => {
    this.state.menuIsOpen = !this.state.menuIsOpen;
    if (this.props.showNavMenu) {
      this.props.dispatch(hideNavMenu());
    } else {
      this.props.dispatch(showNavMenu());
    }
  };

  toggleNavigationItem = (entityId) => {
    const { menuItemsToggled } = this.state;

    this.setState((prevState) => ({
      menuItemsToggled: {
        ...menuItemsToggled,
        [entityId]: !prevState.menuItemsToggled[entityId],
      },
    }));
  };

  render() {
    const { menuItemsToggled } = this.state;

    const { path, entityType } = this.props;

    const navigationMaatjesClassNames = classNames('NavigationMaatjes', {
      'NavigationMaatjes__transparentBackground': TRANSPARENT_NAV_CONTENT_TYPE.includes(entityType),
    });

    return (
      <NavigationScroll>
        <div className="NavigationMaatjes__topBarBg" />
        <Container>
          <div className={navigationMaatjesClassNames} ref={(node) => this.menuNode = node}>
            <Logo />
            <div className="menu-wrapper">
              <div className="NavigationMaatjes__menus">
                <div className="NavigationMaatjes__menus__wrapper">
                  <Menu id="main">
                    {(items) => {
                      return (
                        <>
                          <GenericNavigationMainMobile
                            path={path}
                            items={items}
                            toggleNavigationItem={this.toggleNavigationItem}
                          />
                          <GenericNavigationMainMenu
                            path={path}
                            items={items}
                            toggleNavigationItem={this.toggleNavigationItem}
                            menuItemsToggled={menuItemsToggled}
                          />
                        </>
                      );
                    }}
                  </Menu>
                  <NavigationSecondaryMenu />
                </div>
              </div>
            </div>
            <Button className="NavigationMaatjes__mobile" onClick={this.onHamburgerClick}>
              <div className="NavigationMaatjes__mobile__title">
                {this.state.menuIsOpen ? 'Sluiten' : 'Menu'}
              </div>
              <Hamburger />
            </Button>
          </div>
        </Container>
      </NavigationScroll>
    );
  }
}

/**
 * @example
 * @param state
 * @param ownProps
 */
function mapStateToProps(state, ownProps) {

  return {
    path: state.getIn(['router', 'location', 'pathname']),
    showNavMenu: state.getIn(['uiInternal', 'showNavMenu']),
  };
}

export default withRouter(connect(mapStateToProps)(MaatjesHeader));
